import TheSelection from "./TheSelection.vue";
import TheTerms from "./TheTerms.vue";
import FixitLogin from "./FixitLogin/FixitLogin.vue";
import CreateProfile from "./CreateProfile/CreateProfile.vue"
import Oauth from "./OauthFlow/Oauth.vue"
import TheRedirectLoader from './TheRedirectLoader.vue'

export { TheSelection, TheTerms, FixitLogin, CreateProfile, TheRedirectLoader, Oauth };
